import React from "react";
import omit from "ramda/src/omit";
import mergeLeft from "ramda/src/mergeLeft";
import TableFooter from "@mui/material/TableFooter";

import { EnhancedTable } from "../EnhancedTable";
import { TableFooterPagination } from "../TableFooterPagination";

import { normalize } from "../../helpers/normalize";

import { usePaginationHandler } from "./usePaginationHandler";

import { PaginationTableContext } from "./context";

import { Props } from "./types";

export const PaginatedTable: React.FC<Props> = (props) => {
  const paginationData = usePaginationHandler(props);

  const value = React.useMemo(
    () => mergeLeft(paginationData, { colSpan: props.colSpan }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [normalize(paginationData)]
  );

  return (
    <PaginationTableContext.Provider value={value} {...omit(["endAdornment"], props)}>
      <EnhancedTable title={props.title} endAdornment={props.endAdornment} className={props.className}>
        {props.children}
        <TableFooter>
          <TableFooterPagination />
        </TableFooter>
      </EnhancedTable>
    </PaginationTableContext.Provider>
  );
};
